import { enumElementDrawStates, enumPadBorderType, kCheckDisabled } from "../constants";
import { QButton } from "./QButton";
import { uFramelessPanelColorLighter, uFramelessPanelColorDarker } from "../whitelabel/brand";
import { Globals } from "./Globals";
import { MeasureTextHeight } from "../utils/MeasureTextHeight";

export class QFramelessPanelButton extends QButton {
  constructor() {
    super();
    this.fLabelBuffer = 40;
  }

  DoRenderContent(drawBuffer) {}

  GetRealContent() {
    //Used to simplify true/false checks. Semi-dirty...
    return this.fLabel === kCheckDisabled || this.fLabel === "Yes";
  }

  DrawPad(drawBuffer, mouseDown, selected) {
    var ctx = drawBuffer.getContext("2d");
    var r2d = Math.PI / 180;

    //if (mouseDown)
    //	ctx.strokeStyle = "#7B6645";
    //else
    ctx.strokeStyle = Globals._accountInfo.GetButtonColor();
    ctx.lineWidth = 1;

    var r = 4;
    var sx = this.fHorzOffset + 0.5;
    var sy = this.fVertOffset + 0.5;
    var ex = this.fHorzOffset + this.fWidth - 0.5;
    var ey = this.fVertOffset + this.fHeight - 0.5;

    var bt = this.fPadBorderType;
    switch (bt) {
      case enumPadBorderType.fullBorder:
        ctx.beginPath();
        ctx.moveTo(sx + r, sy);
        ctx.lineTo(ex - r, sy);
        ctx.arc(ex - r, sy + r, r, r2d * 270, r2d * 360, false);
        ctx.lineTo(ex, ey - r);
        ctx.arc(ex - r, ey - r, r, r2d * 0, r2d * 90, false);
        ctx.lineTo(sx + r, ey);
        ctx.arc(sx + r, ey - r, r, r2d * 90, r2d * 180, false);
        ctx.lineTo(sx, sy + r);
        ctx.arc(sx + r, sy + r, r, r2d * 180, r2d * 270, false);
        ctx.closePath();
        ctx.stroke();
        break;
      case enumPadBorderType.leftBorder:
        ctx.beginPath();
        ctx.moveTo(ex + 0.5, sy);
        ctx.lineTo(sx + r, sy);
        ctx.arc(sx + r, sy + r, r, r2d * 270, r2d * 180, true);
        ctx.lineTo(sx, ey - r);
        ctx.arc(sx + r, ey - r, r, r2d * 180, r2d * 90, true);
        ctx.lineTo(ex + 0.5, ey);
        ctx.stroke();
        ctx.closePath();
        break;
      case enumPadBorderType.rightBorder:
        ctx.beginPath();
        ctx.moveTo(sx - 0.5, sy);
        ctx.lineTo(ex - r, sy);
        ctx.arc(ex - r, sy + r, r, r2d * 270, r2d * 360, false);
        ctx.lineTo(ex, ey - r);
        ctx.arc(ex - r, ey - r, r, r2d * 0, r2d * 90, false);
        ctx.lineTo(sx - 0.5, ey);
        ctx.stroke();
        ctx.closePath();
        break;
      case enumPadBorderType.middleBorder:
        ctx.beginPath();
        ctx.moveTo(sx - 0.5, sy);
        ctx.lineTo(ex + 0.5, sy);
        ctx.stroke();
        ctx.moveTo(sx - 0.5, ey);
        ctx.lineTo(ex + 0.5, ey);
        ctx.stroke();
        ctx.lineTo(ex + 0.5, sy);
        ctx.lineTo(sx - 0.5, sy);
        ctx.closePath();
        break;
    }

    // Hover, Selected				-> dark gradient, indent
    // Hover, Not Selected			-> light gradient, no ident
    // Mousedown, Selected			-> dark gradient, indent
    // Mousedown, Not Selected		-> dark gradient, indent

    var gradient = ctx.createLinearGradient(0, sy, 0, ey); // this.fHeight
    ctx.globalAlpha = 0.2;
    if (mouseDown) {
      // Dark gradient
      gradient.addColorStop(0, "#EEEEEE");
      gradient.addColorStop(1, uFramelessPanelColorDarker);
    } else if (this.fIsActive || this.fSelected) {
      // Lighter gradient
      gradient.addColorStop(0, "#FFECDA");
      gradient.addColorStop(1, uFramelessPanelColorLighter);
    } else {
      // Lighter gradient
      gradient.addColorStop(0, "#FFECDA");
      gradient.addColorStop(1, uFramelessPanelColorLighter);
    }
    ctx.fillStyle = gradient;
    ctx.fill();
    ctx.globalAlpha = 1;
  }

  DoRenderElement(drawBuffer) {
    var isToggleButton = this.IsToggleButton();

    var drawAsSelected = isToggleButton ? this.GetToggleState() : false;

    switch (this.GetDrawState()) {
      case enumElementDrawStates.Std:
        if (this.fIsActive || this.fSelected) this.DrawPad(drawBuffer, false, drawAsSelected);
        break;
      case enumElementDrawStates.Hover:
        this.DrawPad(drawBuffer, false, drawAsSelected);
        break;
      case enumElementDrawStates.MouseDown:
        this.DrawPad(drawBuffer, true, drawAsSelected);
        break;
      case enumElementDrawStates.Disabled:
        break;
    }

    this.DoRenderContent(drawBuffer);

    if (this.fShowLabel) {
      this.fUnderlined = this.GetToggleState();
      this.DrawLabel(drawBuffer);
    }
  }

  GetCursor() {
    return "pointer";
  }

  AutoSize() {
    var sizeW = this.fMinW ? this.fMinW : 0;
    var sizeH = this.fMinH ? this.fMinW : 0;
    var l = this.fLabel;

    if (l != "") {
      var labelLen = this.MeasureLabel() + this.fLabelBuffer;
      if (labelLen > sizeW) sizeW = labelLen;
    }
    var labelHeight = MeasureTextHeight(this.fFontString, 18) * 2;
    if (labelHeight > sizeH) sizeH = labelHeight;

    this.SizeElement(sizeW, sizeH);
  }
}
